<template>
    <div class="sdk-dimension-container">
        <div class="flex">
            <el-form :model="params.style" ref="form" :label-width="labelWidth" style="width:600px;">
                <el-form-item label="页面风格：">
                    <el-radio-group v-model="params.style.custom_personal_center_style_allowed" @change="handleCustomStyleAllowed">
                        <el-radio :label="false">默认系统风格 </el-radio>
                        <el-radio :label="true">游戏风格</el-radio>
                    </el-radio-group>
                    <em class="el-icon-view icon-view left-120" @click.stop="personalCenterDefaultDialogVisible = true"></em>
                </el-form-item>
                <el-form-item  
                    :rules="[{ required: params.style.custom_personal_center_style_allowed, message: '请上传背景图', trigger: 'blur' }]" 
                    label="背景图：" prop="personal_center_background" v-if="params.style.custom_personal_center_style_allowed">
                    <div class="flex">
                        <div class="upload-box">
                            <div class="personal-center-font-style">尺寸要求：</div>
                            <div class="personal-center-font-style">横版高度固定1440px，宽度等比缩放，建议宽度大于2560px</div>
                            <div class="personal-center-font-style">竖版宽度固定1440px，高度等比缩放，建议高度大于600px</div>
                            <div class="personal-center-font-style">个人中心的横竖版设置与游戏的横竖版设置一致</div>
                            <upload class="page-style-upload" v-model="params.style.personal_center_background"
                                    formatlimit="all"></upload>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="页面样式：">
                    <el-radio-group v-model="params.style.appearance" @change="handlerDefaultStyle">
                        <el-radio label="light">浅色系 </el-radio>
                        <el-radio label="dark">深色系</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="页面样式：">
                    <el-radio-group v-model="params.style.custom_page_style_allowed"  @change="handlerDefaultStyle">
                        <el-radio :label="false">默认样式</el-radio>
                        <el-radio :label="true">自定义样式</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item label="标题1：">
                    <div class="style-diy-color">
                        <div class="background-color"><div :style="{background: params.diy_colors.title_1}">{{params.diy_colors.title_1}}</div></div>
                        <el-color-picker v-model="params.diy_colors.title_1" :disabled="!params.style.custom_page_style_allowed"></el-color-picker>
                        <em class="el-icon-view icon-view" @click.stop="handlerPreview('title_1')"></em>
                    </div>
                </el-form-item>
                <el-form-item label="内容底框背景色：">
                    <div class="style-diy-color">
                        <div class="background-color"><div :style="{background: params.diy_colors.background_color}">{{params.diy_colors.background_color}}</div></div>
                        <el-color-picker v-model="params.diy_colors.background_color" :disabled="!params.style.custom_page_style_allowed"></el-color-picker>
                        <em class="el-icon-view icon-view" @click.stop="handlerPreview('background_color')"></em>
                    </div>
                </el-form-item>
                <el-form-item label="内容区域背景色：">
                    <div class="style-diy-color">
                        <div class="background-color"><div :style="{background: params.diy_colors.background_color_of_content}">{{params.diy_colors.background_color_of_content}}</div></div>
                        <el-color-picker v-model="params.diy_colors.background_color_of_content" :disabled="!params.style.custom_page_style_allowed"></el-color-picker>
                        <em class="el-icon-view icon-view" @click.stop="handlerPreview('background_color_of_content')"></em>
                    </div>
                </el-form-item>
                <el-form-item label="按钮颜色：">
                    <div class="style-diy-color">
                        <div class="background-color"><div :style="{background: params.diy_colors.color_of_button}">{{params.diy_colors.color_of_button}}</div></div>
                        <el-color-picker v-model="params.diy_colors.color_of_button" :disabled="!params.style.custom_page_style_allowed"></el-color-picker>
                        <em class="el-icon-view icon-view" @click.stop="handlerPreview('color_of_button')"></em>
                    </div>
                </el-form-item>
                <el-form-item label="内容选中高亮背景色：">
                    <div class="style-diy-color">
                        <div class="background-color"><div :style="{background: params.diy_colors.highlight_background_color}">{{params.diy_colors.highlight_background_color}}</div></div>
                        <el-color-picker v-model="params.diy_colors.highlight_background_color" :disabled="!params.style.custom_page_style_allowed"></el-color-picker>
                        <em class="el-icon-view icon-view" @click.stop="handlerPreview('highlight_background_color')"></em>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">{{isIOS ? '下一步' : '完成'}}</el-button>
                </el-form-item>
            </el-form>
            <span class="line"></span>
            <el-tabs v-model="activeName" class="upload-box tabs">
                <el-tab-pane label="横版" name="landscape">
                    <div class="upload-view-landscape">
                        <div class="contents">
                            <img :src="defaultLandscapeUrl" height="294" width="530" v-if="!params.style.custom_personal_center_style_allowed" alt="" srcset="">
                            <template v-else>
                                <img class="zindex-0" :src="params.style.personal_center_background" height="294" alt="" srcset="">
                                <div class="zindex-1 right-conetnt">
                                    <diy-title :titleColor="params.diy_colors.title_1" />
                                    <div class="right-content-bom" :style="{backgroundColor: params.diy_colors.background_color}">
                                        <div class="user-center" :style="backgroundContentColor">
                                            <img src="../../assets/icons/avatar_icon.png" height="50" alt="" srcset="">
                                            <div class="user-info">
                                                <div class="user-name">rolename</div>
                                                <div class="user-server-name">userservername</div>
                                                <div class="user-id">300000010451646</div>
                                            </div>
                                        </div>
                                        <ul class="taps">
                                            <li v-for="(item, i) in randerTaps().tap1" :key="'tap1'+ i" 
                                                :style="backgroundContentColor" @mouseenter="handlerOverCurrentBackground" @mouseleave="handlerOutCurrentBackground">
                                                <div>
                                                    <img :src="item.url" height="28" alt="" srcset="">
                                                    <span>{{item.text}}</span>
                                                </div>
                                                <em class="el-icon-arrow-right"></em>
                                            </li>
                                        </ul>
                                        <ul class="taps">
                                            <li v-for="(item, i) in randerTaps().tap2" :key="'tap1'+ i" 
                                                :style="backgroundContentColor" @mouseenter="handlerOverCurrentBackground" @mouseleave="handlerOutCurrentBackground">
                                                <div>
                                                    <img :src="item.url" height="28" alt="" srcset="">
                                                    <span>{{item.text}}</span>
                                                </div>
                                                <em class="el-icon-arrow-right"></em>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="竖版" name="portrait">
                    <div class="upload-view-portrait">
                        <div class="contents">
                            <img :src="defaultPortraitUrl" class="portrait-img" height="526" width="290" v-if="!params.style.custom_personal_center_style_allowed" alt="" srcset="">
                            <div class="zindex-1 right-conetnt" v-else>
                                <img class="zindex-0"  :src="params.style.personal_center_background" width="290" alt="" srcset="">
                                <div class="right-content-bom background-color"  :style="{backgroundColor: params.diy_colors.background_color}">
                                    <diy-title :titleColor="params.diy_colors.title_1"/>
                                    <div class="user-center" :style="backgroundContentColor" >
                                        <img src="../../assets/icons/avatar_icon.png" height="50" alt="" srcset="">
                                        <div class="user-info">
                                            <div class="user-name">rolename</div>
                                            <div class="user-server-name">userservername</div>
                                            <div class="user-id">300000010451646</div>
                                        </div>
                                    </div>
                                    <ul class="taps">
                                        <li v-for="(item, i) in randerTaps().tap1" :key="'tap1'+ i" 
                                            :style="backgroundContentColor"  @mouseenter="handlerOverCurrentBackground" @mouseleave="handlerOutCurrentBackground">
                                            <div>
                                                <img :src="item.url" height="20" alt="" srcset="">
                                                <span>{{item.text}}</span>
                                            </div>
                                            <em class="el-icon-arrow-right"></em>
                                        </li>
                                    </ul>
                                    <ul class="taps">
                                         <li v-for="(item, i) in randerTaps().tap2" :key="'tap2'+ i" 
                                            :style="backgroundContentColor" @mouseenter="handlerOverCurrentBackground" @mouseleave="handlerOutCurrentBackground">
                                            <div @mouseenter.stop>
                                                <img :src="item.url" height="20" alt="" srcset="">
                                                <span>{{item.text}}</span>
                                            </div>
                                            <em class="el-icon-arrow-right"></em>
                                        </li>
                                    </ul>
                                    <ul class="taps">
                                        <li v-for="(item, i) in randerTaps().tap3" :key="'tap1'+ i" 
                                            :style="backgroundContentColor" @mouseenter="handlerOverCurrentBackground" @mouseleave="handlerOutCurrentBackground">
                                            <div>
                                                <img :src="item.url" height="20" alt="" srcset="">
                                                <span>{{item.text}}</span>
                                            </div>
                                            <em class="el-icon-arrow-right"></em>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        
        <el-dialog
            class="el-dialog__body_self"
            title="默认效果预览"
            :visible.sync="personalCenterDefaultDialogVisible"
            width="720px">
            <div class="flex dialog-img-box">
                <div>
                    <div>iOS横版</div>
                    <img src="../../assets/ios-landscape.png" width="320" alt="" />
                </div>
                <div>
                    <div>Android横版</div>
                    <img src="../../assets/android-landscape.png" width="320" alt="" />
                </div>
            </div>
            <div class="flex dialog-img-box">
                <div>
                    <div>iOS竖版</div>
                    <img src="../../assets/ios-portrait.png" height="568"  alt=""/>
                </div>
                <div>
                    <div>Android竖版</div>
                    <img src="../../assets/android-portrait.png"  height="568"  alt="" />
                </div>
            </div>
        </el-dialog>
         <el-dialog
            title="预览"
            :visible.sync="styleDialogVisible"
            width="1200px">
            <div slot="title">
                <h2>颜色位置预览 <span style="color:#F56C6C;">（该图片仅用来示意颜色在界面中的显示位置，不代表真实效果。）</span></h2>
            </div>
            <img :src="activeUrl" alt="" width="1160" />
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import upload from '../../subComponents/sdkUpload';
import DiyTitle from "./style/DiyTitle.vue";
export default {
    name: 'set-login-allowed',
    components: {
        upload,
        DiyTitle
    },
    data() {
        return {
            activeName: 'landscape',
            platform: '',
            activeUrl: '',
            params: {
                style: {
                    personal_center_background: '',
                    custom_personal_center_style_allowed: true,
                    appearance: '',
                    default_colors: this.initStyleColors(),
                    diy_colors: {},
                    custom_page_style_allowed: false,
                },
                diy_colors: {
                    title_1: '',
                    background_color: '',
                    background_color_of_content: '',
                    color_of_button: '',
                    highlight_background_color: ''
                },
                step: 'style'
            },
            personalCenterDefaultDialogVisible: false,
            styleDialogVisible: false
        }
    },
    props: ['isDetail', 'isCopy','labelWidth'],
    computed: {
        ...mapState(['$helper','$lodash']),
        ...mapState("sdkReleasesEdit", [
            "gameVersion",
            "packageList",
            "packageStoreList",
            "sdkVersion",
            "data"
        ]),
        isIOS() {
            return this.platform === 'IOS';
        },
        backgroundContentColor() {
            return {
                backgroundColor: this.params.diy_colors.background_color_of_content
            }
        },
        defaultLandscapeUrl() {
            const Urls = {
                dark: {
                    iosUrl: require('../../assets/ios-landscape1.png'),
                    androidUrl: require('../../assets/android-landscape1.png'),
                },
                light: {
                    iosUrl: require('../../assets/ios-landscape.png'),
                    androidUrl: require('../../assets/android-landscape.png'),
                },
            }
            return this.isIOS ? Urls[this.params.style.appearance].iosUrl : Urls[this.params.style.appearance].androidUrl;
        },
        defaultPortraitUrl() {
            const Urls = {
                dark: {
                    iosUrl: require('../../assets/ios-portrait1.png'),
                    androidUrl: require('../../assets/android-portrait1.png'),
                },
                light: {
                    iosUrl: require('../../assets/ios-portrait.png'),
                    androidUrl: require('../../assets/android-portrait.png'),
                },
            }
            return this.isIOS ? Urls[this.params.style.appearance].iosUrl : Urls[this.params.style.appearance].androidUrl;
        },
    },
    watch: {
        'data.style'(){
            this.params.style = this.$lodash.cloneDeep(this.data.style);
            this.params.step = 'style';
            this.handlerDefaultStyle();
        },
        "params.style.personal_center_background"(val) {
            if(val) {
                this.$refs['form'].clearValidate('personal_center_background')
            } 
        },
    },
    methods: {
        handlerOverCurrentBackground(e) {
            e.target.style.backgroundColor = this.params.diy_colors.highlight_background_color;
        },
        handlerOutCurrentBackground(e) {
            e.target.style.backgroundColor = this.params.diy_colors.background_color_of_content;
        },
        randerTaps() {
            return {
                tap1: [{
                    text: '账号绑定',
                    url: require('../../assets/icons/account-bind.png')
                },{
                    text: '切换账号',
                    url: require('../../assets/icons/gamekit_switchaccount@2x.png')
                },{
                    text: '修改密码',
                    url: require('../../assets/icons/changepassword.png')
                }],
                tap2: [{
                    text: '充值记录',
                    url: require('../../assets/icons/rechargerecord.png')
                },{
                    text: '礼包兑换',
                    url: require('../../assets/icons/gift.png')
                }],
                tap3: [{
                    text: '客服中心',
                    url: require('../../assets/icons/customerservice.png')
                },{
                    text: '论坛',
                    url: require('../../assets/icons/forum.png')
                }]
            }
        },
        initStyleColors() {
            return {
                dark: {
                    title_1: '#FFFFFF',
                    background_color: '#111111',
                    background_color_of_content: '#202020',
                    color_of_button: '#1765AD',
                    highlight_background_color: '#303030'
                },
                light: {
                    title_1: '#111111',
                    background_color: '#F6F6F6',
                    background_color_of_content: '#FEFEFE',
                    color_of_button: '#177DDC',
                    highlight_background_color: '#E9E9E9'
                },
            }
        },
        currentUrl(key) {
            const urls = {
                title_1: require('../../assets/title1.jpeg'),
                background_color: require('../../assets/background_color.jpeg'),
                background_color_of_content: require('../../assets/background_color_of_content.jpeg'),
                color_of_button: require('../../assets/color_of_button.jpeg'),
                highlight_background_color: require('../../assets/highlight_background_color.jpeg'),
            };
            return urls[key];
        },
        handlerDefaultStyle() {
            if(this.params.style.custom_page_style_allowed && typeof this.params.style.diy_colors[this.params.style.appearance] !== 'undefined') {
                this.params.diy_colors = this.$lodash.cloneDeep(this.params.style.diy_colors[this.params.style.appearance]);
            }else {
                this.params.diy_colors = this.$lodash.cloneDeep(this.params.style.default_colors[this.params.style.appearance]);
            }
        },
        handlerPreview(key) {
            this.activeUrl = this.currentUrl(key);
            this.styleDialogVisible = true;
        },
        handleTemplateReview() {
            this.uploadViewDialogVisible = true;
        },
        handleCustomStyleAllowed(checked) {
            if(!checked) {
                this.params.style.personal_center_background = '';
            }
        },
        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if(valid) {
                    if(this.params.style.custom_page_style_allowed) {
                        this.params.style.diy_colors = this.$lodash.cloneDeep(this.initStyleColors());
                        this.params.style.diy_colors[this.params.style.appearance] = Object.assign(this.params.diy_colors);
                    }else {
                        this.params.style.diy_colors = {};
                    }
                    this.$emit('submit', this.params, this.isIOS ? 5 : 'save')
                }
            })
        }
    },
    created() {
        this.platform = this.$helper.helper.getParamers("platform");
    }
}
</script>
<style lang="scss">
.page-style-upload{
    .upload,.avatar-box{
        width: 325px;
        height: 180px;
        display: block;
        line-height: 200px;
        .avatar{
            width: 325px;
            height: 180px;
        }
        .avatar-uploader-icon{
            font-size: 60px;
        }
    }
    .avatar-box{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        .shade,.content{
            top: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.sdk-dimension-container{
    .flex{
        display: flex;
    }
    .line{
        border-right: 2px dashed #d9d9d9;
        margin: 0 40px;
    }
    .tabs{
        flex: 1;
    }
    .portrait-img{
        margin: 56px auto 0;
        display: block;
    }
    .style-diy-color{
        display: flex;
        .background-color{ 
            flex: 1;
            color: #fff;
            border-radius: 3px;
            margin-right: 10px;
            text-align: center;
            border: 1px solid #e6e6e6;
            padding: 5px;
            div{
                line-height: 28px;
                border-radius: 3px;
                border-radius: 3px;
            }
        }
        .icon-view{
            position: relative;
            left: 8px;
            height: 18px;
            font-size: 20px;
            padding: 8px;
            top: 1px;
            display: table;
        }
    }
    .upload-box{
        div{
            line-height: 24px;
        }
        .personal-center-font-style{
            font-size: 12px;
            color: #E6A23C;
        }
        .avatar-uploader{
            line-height: 0;
            margin-top: 20px;
        }
        .el-icon-view{
            font-size: 30px;
            color: hsla(0,0%,100%,.85);
        }
        .upload-view-landscape,.upload-view-portrait{
            &:hover{
                .shade,.content{
                    opacity: 1;
                }
            }
        }
    
    
    }
    .upload-view-landscape,.upload-view-portrait{
        background: #f6f6f6;
        height: 138px;
        border-radius: 4px;
        margin-top: 10px;
        overflow: hidden;
        position: relative;
    }
    .upload-view-portrait{
        background: url('../../assets/bgiphone2.png') no-repeat;
        background-size: contain;
        box-sizing: content-box;
        width: 322px;
        height: 640px;
        margin: 0 auto;
        .right-conetnt{
            width: 290px;
            height: 426px;
            margin: 56px auto 0;
            background: #f2f2f2;
            padding-top: 100px;
            position: relative;
            z-index: 1;
            .right-content-bom{
                background: #f2f2f2;
                border-radius: 5px;
                position: relative;
                height: inherit;
            }
        }
    }
    .upload-view-landscape {
        background: url('../../assets/bgiphonew.png') no-repeat;
        background-size: contain;
        box-sizing: content-box;
        .right-content-bom{
            background: #f2f2f2;
            padding-top: 10px;
            border-radius: 5px;
        }
    }
    .upload-view-landscape{
        height: 330px;
        width: 664px;
        .contents{
            position: relative;
            background: #f6f6f6;
            height: 294px;
            border-radius: 6px;
            width: 530px;
            margin: 19px auto 0;
            overflow: hidden;
        }
        
    }
    .right-conetnt{
        width: 60%;
        height: 100%;
        right: 0;
        position: absolute;
        z-index: 1;
        .right-conetnt-bom{
            padding: 12px 0;
            background: #f2f2f2;
        }
        
        .user-center, .taps li{
            padding: 6px 10px;
            display: flex;
            align-items: center;
            background: #fff;
        
            margin: 0 10px;
        }
        .user-center{
            border-radius: 5px;
            div{
                line-height: 20px;
                margin-left: 10px;
            }
        }
        .taps{
            margin-top: 10px;
            li{
                justify-content: space-between;
                div{
                    display: flex;
                    align-items: center;
                }
                span{
                    margin-left: 10px;
                    font-size: 14px;
                }
                border-bottom: 1px solid #f6f6f6;
            }
            li:first-child{
                border-radius: 5px 5px 0 0;
            }
            li:last-child{
                border: none;
                border-radius: 0 0 5px 5px;
            }
        }
    }
    .zindex-0{
        position: absolute;
        z-index: 0;
        top:0;
        left: 0;
    }
}

</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SetPageStyle.vue